module.exports = __webpack_public_path__ + "img/171.02fd0922.jpg";